export default "__VITE_ASSET__js4Qbp11__"